// extracted by mini-css-extract-plugin
export default {"popup":"Ws2e0","popupPE":"o0wVq"};